import { Drawer, type DrawerProps } from "@mantine/core";
import type { ReactNode } from "react";

export interface RecordDrawerProps extends Omit<DrawerProps, "title" | "children"> {
  readonly title: string;
  /** Short line under the title identifying the record (name, id, status). */
  readonly subtitle?: ReactNode;
  readonly children: ReactNode;
}

/** Right-side drawer for viewing or editing one record without leaving the list. Full width on phones. */
export function RecordDrawer({ title, subtitle, children, ...rest }: RecordDrawerProps) {
  return (
    <Drawer position="right" size="lg" title={title} padding="lg" {...rest}>
      {subtitle}
      {children}
    </Drawer>
  );
}
